import { LicenseInfo } from '@mui/x-license';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import App from './App.js'

import './locales/i18n' // Initialize localization with react-i18next
import { ConfigProvider } from "./contexts/configContext";
import { MUI_LICENSE_KEY } from "./helpers/constants";
import store, { persistor } from './store/store' // Redux store
import './index.css'
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

LicenseInfo.setLicenseKey(MUI_LICENSE_KEY); // Mui-x license

createRoot(document.getElementById('root')).render(
	<StrictMode>
		<ConfigProvider>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<App/>
				</PersistGate>
			</Provider>
		</ConfigProvider>
	</StrictMode>,
)
